import { render, staticRenderFns } from "./MagnifyIcon.vue?vue&type=template&id=c86984ec&"
import script from "./MagnifyIcon.vue?vue&type=script&lang=js&"
export * from "./MagnifyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports